module.exports = __webpack_public_path__ + "static/img/xl2.922f8ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/control2/xl2.png
// module id = DmIf
// module chunks = 7